import React, { useState, useEffect } from 'react'
import { GET_VERIFIER_FORM_DASH, GET_FORM_SHARE_LINK, BASE_URL, USER_TOKEN } from '../../../Utils/constant'
import API from '../../../ApiConfig'
import { useSelector } from "react-redux";
import { Icon } from 'react-icons-kit'
import { printer } from 'react-icons-kit/ikons/printer'

import { download } from 'react-icons-kit/ikons/download'
import useRefreshToken from '../../../Hooks/usegenerateToken';
export const GenerateQR = ({ form_uuid, verifier_id }) => {
    useRefreshToken(BASE_URL + USER_TOKEN)
    const User = useSelector(state => state.User)
    const [list, setList] = useState({})
    const [apiData, setApiData] = useState({})
    const [loading, setLoading] = useState(false)
    const [qrLink, setQrLink] = useState('')
    const [error, seterror] = useState(null)

    useEffect(() => { generateQRLink() }, [])

    const generateQRLink = () => {
        setLoading(true)
        API.post(GET_FORM_SHARE_LINK + `${form_uuid}/${verifier_id}`)
            .then(res => {
                if (res.data.status === 200) {
                    setQrLink(res.data.data)
                }
            })
            .catch(err => {
                seterror('Something went wrong while fetching ')
            })
            .finally(() => setLoading(false))
    }

    const downloadImage = async (value) => {
        const originalImage = value;
        const image = await fetch(originalImage);
        const nameSplit = originalImage.split("/");
        const duplicateName = nameSplit.pop();

        const imageBlog = await image.blob()
        const imageURL = URL.createObjectURL(imageBlog)
        const link = document.createElement('a')
        link.href = imageURL;
        link.download = "" + duplicateName + "";
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    }

    function printimage(value) {
        const printWindow = window.open(value, '_blank');
        printWindow.document.write(`
          <html>
            <head>
              <style>
                @media print {
                  body, html {
                    margin: 0;
                    padding: 0;
                    width: 100%;
                    height: 100%;
                  }
                  body, html {
                    margin: 0;
                    padding: 0;
                    width: 100%;
                    height: 100%;
                  }
                  img {
                    display: block;
                    margin: auto;
                    max-width: 90%;
                    max-height: 100%;
                    border:2px solid black;
                    border-radius:10px
                  }
                }
                footer {
                    display:flex;
                    justify-content:end;
                }
              </style>
            </head>
            <body>
              <img src="${value}" onload="window.print();window.close()" />
            </body>
          </html>
        `);
        printWindow.document.close();
    }

    if (error)
        return (
            <div className='qr' style={{ padding: '1rem' }}>
                Unable to Generate QR code
            </div>
        )

    else {
        return (
            <>
                <div className='QRContainer'>
                    <div className='qrBtn'>
                        <span className='icon' onClick={() => printimage(qrLink)} title='Print'> <Icon icon={printer} size={20} /></span>

                        <span className='icon' onClick={() => downloadImage(qrLink)} title='download'> <Icon icon={download} size={20} /></span>
                    </div>
                </div>
                <div className='qr'>
                    <img
                        style={{ height: '50%', width: '50%', border: "2px solid black", borderRadius: "15px", margin: "10px" }}
                        src={qrLink}
                        // onError={() => seterror(true)}
                    />
                </div>
            </>
        )
    }
}
